import type { CollectableItem } from "./collectableItem";
import { deserializeItem } from "./serialization";

export class Inventory {
	items: Map<string, CollectableItem> = new Map();

	addItem(item: CollectableItem): void {
		const key = (item.constructor as any).key;
		const existing = this.items.get(key);
		if (existing) {
			existing.count += item.count;
		} else {
			this.items.set(key, item);
		}
	}

	getItemOfClass<T extends CollectableItem>(cls: new (...args: any[]) => T): T | null {
		const key = (cls as any).key;
		const item = this.items.get(key);
		return (item as T | undefined) ?? null;
	}

	getItemByKey(key: string): CollectableItem | null {
		return this.items.get(key) ?? null;
	}

	consumeOne<T extends CollectableItem>(cls: new (...args: any[]) => T): boolean {
		return this.consumeOneByKey((cls as any).key);
	}

	consumeOneByKey(key: string): boolean {
		const item = this.items.get(key);
		if (!item || item.count <= 0) return false;
		item.count--;
		if (item.count <= 0) this.items.delete(key);
		return true;
	}

	getAllItems(): CollectableItem[] {
		return [...this.items.values()];
	}

	serialize(): Record<string, unknown> {
		return { items: this.getAllItems().map((i) => i.serialize()) };
	}

	static deserialize(data: any): Inventory {
		const inv = new Inventory();
		if (data && Array.isArray(data.items)) {
			for (const itemData of data.items) {
				inv.addItem(deserializeItem(itemData));
			}
		}
		return inv;
	}
}
